import { render, staticRenderFns } from "./AllowancesPlanEdit.vue?vue&type=template&id=70b2e13d&scoped=true&"
import script from "./AllowancesPlanEdit.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2e13d",
  null
  
)

export default component.exports